import React from 'react'
import OperationsContext from '../contexts/OperationsContext'

export default function useOperation () {
  return React.useContext(OperationsContext)
}
